import * as types from '@/store/mutation-types'
import {login, logout, register, execCountUsers, askReset, changePassword, updateUserData} from '@/api/client-api'

export default {
  state: {
    authenticated: false,
    token: null,
    redirect: null,
    user: {},
    idExploitation: null,
    nbUsers: 0
  },
  mutations: {
    [types.LOGIN] (state, info) {
      state.authenticated = true
      state.user = info.user
      state.idExploitation = info.idExploitation
    },
    [types.TOKEN] (state, token) {
      state.token = token
    },
    [types.LOGOUT] (state) {
      state.token = null
      state.authenticated = false
      state.redirect = null
    },
    [types.REDIRECT] (state) {
      state.token = null
      state.authenticated = false
      state.redirect = null
    },
    [types.REDIRECT] (state, url) {
      state.redirect = url
    },
    [types.NBUSERS] (state, nbUsers) {
      state.nbUsers = nbUsers
    },
    [types.UPDATE_USER] (state, info) {
      state.user = info
    }
  },
  actions: {
    login: ({ commit }, payload) => {
      commit(types.ADD_LOADING_MESSAGES, 'Connexion')
      return login(payload)
        .then(info => {
          commit(types.LOGIN, info)
        })
        .finally(() => {
          commit(types.DEL_LOADING_MESSAGES)
        })
    },
    register: ({ commit, dispatch }, payload) => {
      commit(types.ADD_LOADING_MESSAGES, 'Inscription')
      return register(payload)
        .finally(() => {
          commit(types.DEL_LOADING_MESSAGES)
        })
    },
    logout: ({ commit }) => {
      return logout()
        .finally(() => {
          commit(types.LOGOUT)
          commit(types.SET_EXPLOITATIONS, [])
          commit(types.SET_INFORMATION, null)
          commit(types.TOKEN, null)
        })
    },
    askReset: ({ commit }, payload) => {
      commit(types.ADD_LOADING_MESSAGES, 'Envoi du mail')
      return askReset(payload, 'forget')
        .finally(() => {
          commit(types.DEL_LOADING_MESSAGES)
        })
    },
    changePassword: ({ commit }, payload) => {
      commit(types.ADD_LOADING_MESSAGES, 'Changement de mot de passe')
      return changePassword(payload)
        .finally(() => {
          commit(types.DEL_LOADING_MESSAGES)
        })
    },
    countUsers: ({ commit, state }) => {
      if (state.authenticated === true && state.user.role === 'admin') {
        execCountUsers()
          .then((r) => {
            commit(types.NBUSERS, r)
          })
          .catch(() => {})
      }
    },
    updateUserData: ({ commit, state }, payload) => {
      return updateUserData(payload, state.user.id_user )
        .then((r) => {
          commit(types.UPDATE_USER, r)
        })
    }
  }
}
